import { useState, useRef, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import ZonaCargando from "../alertas/zonaCargando";
import CambiarContrasena from "../sesion/cambiarContra";

function MiCuentaAdmin() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {};
    const [cargando, setCargando] = useState(false);
    const inputAvatarRef = useRef(null);
    const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando);

    const [perfil, setPerfil] = useState({ nombre: "", apellido: "" });

    useEffect(() => {
        if (!usuario) return;
        setPerfil({
            nombre:   usuario.nombre   || "",
            apellido: usuario.apellido || "",
        });
    }, [usuario]);

    function cambiarCampo(campo, valor) {
        setPerfil(prev => ({ ...prev, [campo]: valor }));
    }

    function abrirSelectorAvatar() {
        if (inputAvatarRef.current) inputAvatarRef.current.click();
    }

    async function subirAvatar(e) {
        try {
            setCargando(true);
            const files = e.target.files;
            if (!files || files.length === 0) return;

            const formData = new FormData();
            formData.append("imagen", files[0]);

            await axios.post("/subir-avatar", formData, {
                headers: { "Content-Type": "multipart/form-data" },
                params: { usuario: usuario.username },
            });

            window.location.reload();
        } catch (err) {
            console.log("Error al subir avatar:", err);
            Swal.fire({ icon: "error", title: "Error al subir", text: "No se pudo subir la imagen. Intenta de nuevo." });
        } finally {
            setCargando(false);
        }
    }

    async function guardarPerfil() {
        if (!perfil.nombre.trim() || !perfil.apellido.trim()) {
            return Swal.fire({ icon: "error", title: "Datos incompletos", text: "Por favor completa nombre y apellido." });
        }

        try {
            setCargando(true);
            await axios.post("/actualizar-perfil", {
                params: {
                    idUsuario: usuario.idUsuario,
                    tipoActualizacion: "Personal",
                    datos: {
                        nombre:            perfil.nombre.trim(),
                        apellido:          perfil.apellido.trim(),
                        // conservamos los demás campos existentes para no sobreescribir con "NA"
                        telefono:          usuario.telefono          || "NA",
                        ciudad:            usuario.ciudad            || "NA",
                        pais:              usuario.pais              || "Colombia",
                        tipoIdentificacion: usuario.tipoIdentificacion || "Identificación nacional",
                        identificacion:    usuario.identificacion    || "NA",
                    },
                },
            });

            await Swal.fire({ icon: "success", title: "Perfil actualizado", text: "Tus datos se guardaron correctamente.", timer: 1600, showConfirmButton: false });
            window.location.reload();
        } catch (err) {
            console.log("Error al guardar perfil:", err);
            Swal.fire({ icon: "error", title: "No se pudo guardar", text: "Ocurrió un error. Intenta de nuevo." });
        } finally {
            setCargando(false);
        }
    }

    if (cargandoFinal) return <ZonaCargando />;
    if (!usuario) return null;

    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between flex-wrap align-items-center pt-3 pb-2 mb-4 border-bottom gap-2">
                <div>
                    <h1 className="h2 text-dark mb-1">Mi cuenta</h1>
                    <p className="text-muted mb-0 small">Gestiona tu perfil de administrador.</p>
                </div>
                <CambiarContrasena usuario={usuario.username} setUsuario={setUsuario} />
            </div>

            <div className="row justify-content-center">
                <div className="col-12 col-md-9 col-lg-6">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-body p-4 p-md-5">

                            {/* Avatar */}
                            <div className="d-flex flex-column align-items-center mb-4">
                                <div className="position-relative overflow-hidden mb-3" style={{ width: 120, height: 120, borderRadius: "50%" }}>
                                    <img
                                        src={usuario.avatar}
                                        alt="Avatar"
                                        style={{ width: 120, height: 120, objectFit: "cover", cursor: "pointer", borderRadius: "50%" }}
                                        onClick={abrirSelectorAvatar}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-dark btn-sm position-absolute start-0 bottom-0 w-100 rounded-0"
                                        style={{ opacity: 0.85, fontSize: "0.75rem" }}
                                        onClick={abrirSelectorAvatar}
                                    >
                                        Cambiar foto
                                    </button>
                                    <input
                                        ref={inputAvatarRef}
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        onChange={subirAvatar}
                                    />
                                </div>
                                <h2 className="h5 fw-bold text-dark mb-1">
                                    {[usuario.nombre, usuario.apellido].filter(Boolean).join(" ") || "Sin nombre"}
                                </h2>
                                <span className="badge rounded-pill mb-2" style={{ background: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)", color: "var(--azul-bootstrap-cta)", fontSize: "0.8rem" }}>
                                    {usuario.tipo || "Administrador"}
                                </span>
                                <p className="text-muted small mb-0">
                                    <i className="bi bi-at me-1"></i>{usuario.username}
                                </p>
                                <p className="text-muted small mb-0">
                                    <i className="bi bi-envelope me-1"></i>{usuario.email}
                                </p>
                            </div>

                            <hr className="my-4" />

                            {/* Formulario nombre */}
                            <h5 className="fw-bold mb-3">Información personal</h5>
                            <div className="row g-3 mb-4">
                                <div className="col-12 col-sm-6">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nombre"
                                            value={perfil.nombre}
                                            onChange={(e) => cambiarCampo("nombre", e.target.value)}
                                        />
                                        <label>Nombre</label>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Apellido"
                                            value={perfil.apellido}
                                            onChange={(e) => cambiarCampo("apellido", e.target.value)}
                                        />
                                        <label>Apellido</label>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button
                                        type="button"
                                        className="btn btn-primary w-100"
                                        onClick={guardarPerfil}
                                        disabled={cargando}
                                    >
                                        <i className="bi bi-check2-circle me-2"></i>
                                        {cargando ? "Guardando..." : "Guardar cambios"}
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MiCuentaAdmin;
